import { getFileExtensionFromUrl } from './formatters';

// Resolve the ordered list of image URLs to display for an analysis result,
// preferring locally-generated previews over server blobs where appropriate
// (e.g. HEIC/HEIF that the browser can't render, or when the server image
// errored). Extracted verbatim from AnalysisPage so the page stays focused.
export function buildAnalysisDisplayImageUrls(analysisResult, previewUrls, resultImageErrors) {
  const analysisServerImageUrls = analysisResult
    ? (
      Array.isArray(analysisResult.blob_urls) && analysisResult.blob_urls.length > 0
        ? analysisResult.blob_urls
        : (analysisResult.blob_url ? [analysisResult.blob_url] : [])
    )
    : [];
  const analysisImageCount = Math.max(analysisServerImageUrls.length, previewUrls.length);
  const usePreviewFirst = (
    previewUrls.length > 0
    && analysisServerImageUrls.length > 0
    && previewUrls.length === analysisServerImageUrls.length
  );
  return Array.from({ length: analysisImageCount }, (_, index) => {
    const serverUrl = analysisServerImageUrls[index] || '';
    const previewEntry = previewUrls[index] || {};
    const previewUrl = previewEntry?.url || '';
    const serverExtension = getFileExtensionFromUrl(serverUrl);
    if (
      usePreviewFirst
      && previewUrl
      && !previewEntry?.isConverting
      && !previewEntry?.hasPreviewError
    ) {
      return previewUrl;
    }
    const shouldUsePreview = Boolean(resultImageErrors[index]) || serverExtension === 'heic' || serverExtension === 'heif';
    if (shouldUsePreview && previewUrl) {
      return previewUrl;
    }
    return serverUrl || previewUrl || '';
  });
}
